<template>
  <div
    class="relative z-20 w-full max-w-screen-2xl mx-auto flex flex-col md:flex-row items-center justify-center px-4 sm:px-6 md:px-2 lg:px-16 xl:px-20 gap-10 md:gap-12 mt-[-40px] sm:mt-0"
    :class="{ 'md:flex-row-reverse': !imageLeft }"
  >
    <div class="w-full md:w-1/2 flex justify-center md:justify-end">
      <img
        :src="imageSrc"
        :alt="imageAlt"
        class="w-full h-auto transform scale-[1.2] md:scale-[1.5] lg:scale-[1.4]"
      />
    </div>

    <div class="w-full md:w-1/2 flex justify-center md:justify-start">
      <div
        class="flex flex-col items-center md:items-start gap-5 text-center md:text-left w-full max-w-lg"
      >
        <h2 class="text-2xl sm:text-xl font-semibold text-gray-900">
          {{ title }}
        </h2>
        <p
          class="text-sm sm:text-base md:text-lg text-gray-900 leading-relaxed"
          v-html="text"
        ></p>
        <div
          class="flex gap-4 sm:gap-5 md:gap-6 items-center justify-center md:justify-start flex-wrap"
          v-if="logos.length"
        >
          <a
            :href="logo.url"
            target="_blank"
            v-for="(logo, index) in logos"
            :key="index"
          >
            <img
              :src="`${logo.imageSrc}`"
              :alt="logo.imageAlt"
              class="h-5 sm:h-6 md:h-8 lg:h-10 w-auto"
            />
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    title: String,
    text: String,
    imageSrc: String,
    imageAlt: String,
    imageLeft: {
      type: Boolean,
      default: true,
    },
    logos: Array,
  },
};
</script>
